export const STORE_LINK_HOST = 'mycardshop.online'

const RESERVED_SLUGS = new Set([
  'pricing',
  'feed',
  'discover',
  'dashboard',
  'store',
  'login',
  'signup',
  'auth',
  'admin',
  'api',
  'home',
  'search',
  'messages',
])

export function slugifyStoreName(name?: string) {
  const words = (name || '')
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean)

  const slug = words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')

  if (!slug) return 'MyStore'
  if (RESERVED_SLUGS.has(slug.toLowerCase())) return `${slug}Shop`
  return slug
}

export function getStorePath(profile?: { storeSlug?: string; storeName?: string; userId?: string } | null) {
  if (profile?.storeSlug) return `/${profile.storeSlug}`
  if (profile?.storeName) return `/${slugifyStoreName(profile.storeName)}`
  return profile?.userId ? `/store/${profile.userId}` : '/dashboard'
}

export function getStoreUrlPreview(storeName?: string, storeSlug?: string) {
  return `${STORE_LINK_HOST}/${storeSlug || slugifyStoreName(storeName)}`
}
